import Link from "next/link";
import { pageHref } from "@/lib/pages";
import { getCrossLinkPages } from "@/lib/pages-nav";

export default function CalculatorCrossLinks({
  currentPage,
  title = "More Free Calculators",
}: {
  currentPage: string;
  title?: string;
}) {
  const links = getCrossLinkPages(currentPage);

  return (
    <div className="mt-12">
      <div className="divider-warm mb-8" />
      <h2 className="text-[22px] sm:text-[26px] font-bold text-center mb-6 text-[var(--ish-dark)]">
        {title}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {links.map((calc) => (
          <Link
            key={calc.slug}
            href={pageHref(calc)}
            className="group flex min-h-[76px] items-center gap-3.5 rounded-xl border border-[var(--ish-border)] bg-[var(--ish-bg-card)] p-4 shadow-[0_1px_3px_rgba(0,0,0,0.04)] transition-all duration-200 hover:border-[var(--ish-accent-border)] hover:bg-[var(--ish-accent-light)]"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[var(--ish-accent-light)] text-xl transition-transform duration-200 group-hover:scale-105">
              {calc.icon}
            </span>
            <div className="min-w-0">
              <span className="block text-[14px] font-bold text-[var(--ish-dark)]">
                {calc.title}
              </span>
              <span className="mt-0.5 line-clamp-1 block text-[12px] text-[var(--ish-text-faint)]">
                {calc.description}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
